import "core-js/modules/es6.regexp.match";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.split";
import keys from 'lodash/keys';
import transform from 'lodash/transform';
import invert from 'lodash/invert';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import flatten from 'lodash/flatten';
import { stringify } from 'qs';
const PRODUCTS_PER_PAGE = 40;
const IMAGES_PER_PAGE = 48;
const SORT_BY = {
  popular: 'popular',
  publishdate: 'publishdate',
  price: 'price'
};
const ORDER_BY = {
  default: 'default',
  asc: 'asc',
  desc: 'desc'
};
const ENCODED_CATEGORY_FILTERS = {
  color: 'c',
  style: 'st',
  fabric: 'f',
  plus_product: 'pp',
  capacity: 'ca',
  form: 'fo',
  model: 'm',
  ideal_for: 'if',
  more_info: 'mi',
  size_dimensions: 'sd',
  theme: 't',
  price: 'p',
  depth: 'dd',
  height: 'dh',
  width: 'dw',
  category: 'ct',
  offers: 'of'
};
const ENCODED_LOOKBOOK_FILTERS = {
  collection: 'key'
};
const DECODED_CATEGORY_FILTERS = invert(ENCODED_CATEGORY_FILTERS);
const DECODED_LOOKBOOK_FILTERS = invert(ENCODED_LOOKBOOK_FILTERS);

const supportedFilterBy = (query, decoder) => {
  const supported = keys(decoder);
  return transform(query, (currentQuery, value, key) => {
    const isSupported = supported.includes(key) && value !== '';
    return Object.assign(currentQuery, isSupported && {
      [key]: value
    });
  }, {});
};

const extractFilterByFromQuery = decoder => query => transform(supportedFilterBy(query, decoder), (result, value, key) => {
  const currentResult = result;
  currentResult[decoder[key]] = !isEmpty(value) ? value.split(',') : [];
}, {});

const extractQueryFromFilterBy = encoder => query => transform(query, (result, value, key) => {
  const currentResult = result;
  currentResult[encoder[key]] = value.length ? value.join(',') : null;
}, {});

const extractCategoryQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_CATEGORY_FILTERS);
const extractCategoryFilterByFromQuery = extractFilterByFromQuery(DECODED_CATEGORY_FILTERS);
const extractLookbookQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_LOOKBOOK_FILTERS);
const extractLookbookFilterByFromQuery = extractFilterByFromQuery(DECODED_LOOKBOOK_FILTERS);

const extractCategorySortByFromQuery = query => SORT_BY[query.sort] || SORT_BY.popular;

const extractCategoryOrderByFromQuery = query => ORDER_BY[query.order] || null;

const extractPageFromQuery = query => parseInt(query.page, 10) || 1;

const extractCategoryPreviousPageFromQuery = extractPageFromQuery;
const extractCategoryNextPageFromQuery = extractPageFromQuery;

const assembleCategoryQuery = query => {
  const filters = supportedFilterBy(query, DECODED_CATEGORY_FILTERS);

  const aggregated = _objectSpread({
    from: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    size: PRODUCTS_PER_PAGE,
    sort: extractCategorySortByFromQuery(query),
    order: extractCategoryOrderByFromQuery(query)
  }, filters);

  return stringify(omitBy(aggregated, isNil));
};

const buildCategoryProductsQuery = query => {
  const filterBy = extractCategoryFilterByFromQuery(query);
  const sortBy = extractCategorySortByFromQuery(query) || SORT_BY.popular;
  const orderBy = extractCategoryOrderByFromQuery(query) || ORDER_BY.default;
  return {
    offset: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    limit: PRODUCTS_PER_PAGE,
    sortBy: sortBy.toUpperCase(),
    orderBy: orderBy.toUpperCase(),
    filterBy: keys(filterBy).map(e => ({
      filter: e,
      facets: filterBy[e]
    }))
  };
};

const assembleLookbookQuery = query => {
  const filters = supportedFilterBy(query, DECODED_LOOKBOOK_FILTERS);

  const aggregated = _objectSpread({
    from: (extractPageFromQuery(query) - 1) * IMAGES_PER_PAGE,
    size: IMAGES_PER_PAGE
  }, filters);

  return stringify(omitBy(aggregated, isNil));
};

const extractCategoryHash = url => {
  const regex = /\w*(?=\.html?)|\w*$/;
  return url.match(regex) ? url.match(regex)[0] : null;
};

const extractCategorySlugFromUrl = url => {
  const regex = /(\w([a-z]|[A-Z]|[0-9]){0,}(-)){1,}/g;
  const match = url.match(regex);
  return match ? match[0].substr(0, url.match(regex)[0].length - 1) : null;
};

const extractProductReference = url => {
  const regex = /\d{3,}/g;
  return url.match(regex) ? url.match(regex).slice(-1)[0] : null;
};

const extractFacetLabelFromCategoryFilters = (filters, filter, facet) => {
  if (filter === 'price') return facet;
  const extracted = filters.find(e => e.name === filter).facets.find(e => e.key === facet);
  return extracted ? extracted.label : null;
};

const extractSelectedFilters = (filterBy, filters) => {
  if (!filters) return [];
  const result = [];
  keys(filterBy).forEach(filter => {
    const hasFilter = filters ? filters.find(e => e.name === filter) : false;

    if (hasFilter) {
      result.push(filterBy[filter].map(facet => ({
        filter,
        facet,
        label: extractFacetLabelFromCategoryFilters(filters, filter, facet)
      })));
      return;
    }

    const hasDeepFilter = ['depth', 'width', 'height'].includes(filter);

    if (hasDeepFilter) {
      result.push({
        filter,
        facet: filterBy[filter][0],
        label: "".concat(filterBy[filter][0], " cm")
      });
    }
  });
  return flatten(result);
};

export { extractCategoryHash, extractCategorySlugFromUrl, extractProductReference, extractCategoryFilterByFromQuery, extractCategoryQueryFromFilterBy, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractFacetLabelFromCategoryFilters, extractLookbookQueryFromFilterBy, extractLookbookFilterByFromQuery, extractSelectedFilters, assembleCategoryQuery, assembleLookbookQuery, buildCategoryProductsQuery };